import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-role-and-permissions-sidebar',
  templateUrl: './role-and-permissions-sidebar.component.html',
  styleUrl: './role-and-permissions-sidebar.component.scss',
  standalone: false
})
export class RoleAndPermissionsSidebarComponent implements OnInit {
  @Output() itemSelected = new EventEmitter<number>();
  @Input() sidebarItems: {id: number, name: string}[] = [];
  selectedItem: number = 0;

  ngOnInit(): void {
    this.selectedItem = this.sidebarItems[0].id;
  }

  selectItem(item: number) {
    this.selectedItem = item;
    this.itemSelected.emit(item);
  }
}
